import { Transition } from '@lounge-fe/ui-kit'
import { useFadeInOut } from './FadeInOutProvider'
import type { AnimateProps } from './types'

export const Animate: React.FC<React.PropsWithChildren<AnimateProps>> = ({
  className,
  children,
}) => {
  const { showAnimateComponent, setShowInitialComponent } = useFadeInOut()

  return (
    <Transition.Fade
      show={showAnimateComponent}
      className={className}
      onAnimationEnd={() => {
        if (!showAnimateComponent) {
          setShowInitialComponent(true)
        }
      }}
    >
      {children}
    </Transition.Fade>
  )
}
